import TemplateApi from "../api/TemplateApi";
import * as types from "../constants/actionConstants";
import {closeDrawer} from "./drawerActions";
import {initGetTemplateList} from "./templateListActions";
import * as TEMPLATE from "../constants/templateConstants";
import * as portalTypes from "../portal/constants/actionConstants";
import {runTrackedTemplateSave} from "./templateSaveActions";
import {
    captureEditorOrigin,
    runIfEditorOwnerActive
} from "../utilities/editorInstanceOwnership";


export function getQuestionTemplate(questionKey = "", id) {
    let thunk = (dispatch)=>{
        dispatch({type: types.QUESTION_TEMPLATE_GET_INIT, questionKey});

        // If no ID or Key then make no call, new questions have no ID or Key yet.

        // Always get by ID when provided to guarantee you get the exact template specified
        if (id) {
            TemplateApi.getQuestionById(id).then((questionTemplate) =>{
                dispatch({type: types.QUESTION_TEMPLATE_GET_SUCCESS , questionTemplate});
            });
        }
        else if (questionKey !== "") {
            // There can be no ID, i.e. in the case of the question being the collection relating to another template
            // Then the collection is stored as an array of keys only, that ensures you always get the current version.
            TemplateApi.getCurrentQuestion(questionKey).then((questionTemplate) =>{
                dispatch({type: types.QUESTION_TEMPLATE_GET_SUCCESS , questionTemplate});
            });
        }

        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };

    thunk.meta = {
        debounce: {
            time: 2000,
            key: id || questionKey,
            leading: true,
            trailing: false
        }
    };

    return thunk;
}

export function saveQuestionTemplate(questionTemplateObject) {
    return (dispatch)=>{
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.saveQuestionTemplate(questionTemplateObject)
            .then((questionTemplate) =>{
                dispatch({type: types.QUESTION_TEMPLATE_UPDATE_SUCCESS , questionTemplate});
                setTimeout(() => {
                    dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
                }, 500);
                return questionTemplate;
            })
        );
    };
}

export function saveQuestionTemplateAndCloseDrawer(questionTemplateObject, filter, versionsFilter, templateMode, filterState, requestOwner = null) {
    const owner = captureEditorOrigin(requestOwner);
    return (dispatch, getState)=>{
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.saveQuestionTemplate(questionTemplateObject)
            .then((questionTemplate) =>{
                dispatch({type: types.QUESTION_TEMPLATE_UPDATE_SUCCESS , questionTemplate});
                runIfEditorOwnerActive(getState, owner, () => dispatch(closeDrawer()));

                // Best to load question list page in all cases
                dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.QUESTION, TEMPLATE.MODE.CURRENT));
                if (templateMode === TEMPLATE.MODE.VERSIONS) {
                    let tempVersionsFilter = {...versionsFilter};
                    tempVersionsFilter.templateName = questionTemplateObject.name;
                    tempVersionsFilter.templateKey = questionTemplateObject.templateKey;
                    tempVersionsFilter.defaultActions = filterState.defaultActions;
                    dispatch(initGetTemplateList(tempVersionsFilter, TEMPLATE.TYPE.QUESTION, TEMPLATE.MODE.VERSIONS));
                }
                return questionTemplate;
            })
        );
    };
}

export function saveQuestionTemplateTagsAndCloseDrawer(questionTemplateObject, requestOwner = null) {
    const owner = captureEditorOrigin(requestOwner);
    return (dispatch, getState)=>{
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.saveQuestionTemplateTags(questionTemplateObject).then((questionTemplate) =>{
                dispatch({type: types.QUESTION_TEMPLATE_TAGS_UPDATE_SUCCESS , questionTemplate});
                runIfEditorOwnerActive(getState, owner, () => dispatch(closeDrawer()));
                return questionTemplate;
            })
        );
    };
}

export function createQuestionTemplate(questionTemplateObject, depth, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch) => {
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.createQuestionTemplate(questionTemplateObject)
            .then((questionTemplate) => {
                dispatch({type: types.QUESTION_TEMPLATE_CREATE_SUCCESS, questionTemplate, depth, origin});
                setTimeout(() => {
                    dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
                }, 500);
                return questionTemplate;
            })
        );
    };
}

export function createQuestionTemplateAndCloseDrawer(questionTemplateObject, depth, filter, onSuccess = ()=>{}, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch, getState) => {
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.createQuestionTemplate(questionTemplateObject)
            .then((questionTemplate) => {
                dispatch({type: types.QUESTION_TEMPLATE_CREATE_SUCCESS, questionTemplate, depth, origin});
                runIfEditorOwnerActive(getState, origin, () => {
                    onSuccess();
                    dispatch(closeDrawer());
                });
                dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.QUESTION, TEMPLATE.MODE.CURRENT));
                setTimeout(() => {
                    dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
                }, 500);
                return questionTemplate;
            })
        );
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// Questions show group keys
// ---------------------------------------------------------------------------------------------------------------------

export function  addQuestionTemplateShowGroupKeys(template, showGroupKeys = [], depth = 0) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: types.QUESTION_TEMPLATE_ADD_SHOW_GROUP_KEYS, payload: {template}, showGroupKeys: showGroupKeys, depth: depth});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function  setQuestionTemplateShowGroupKeys(template, showGroupKeys = [], depth = 0) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: types.QUESTION_TEMPLATE_SET_SHOW_GROUP_KEYS, payload: {template}, showGroupKeys: showGroupKeys, depth: depth});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}





